import React from "react";

export const PettyCash = React.lazy(() => import("./PettyCash"));
export const Invoice = React.lazy(() => import("./Invoice"));
export const GiftVoucher = React.lazy(() => import("./GiftVoucher"));
